/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowYogaClassTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowYogaClass,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Breathe and Stretch!",
    "Yoga Flow Awaits!",
    "Find Your Zen!",
  ],
  title: "Yoga Class",
  description: "Organize a relaxing yoga class.",
  longDescription:
    "Gather your friends for a soothing yoga class! Choose a date, decide on the style of yoga, and plan refreshments for afterward!",
  emoji: "🧘",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Yoga Class",
          emoji: "🧘",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the yoga class?",
          emoji: "📅",
          completeAction: {
            question: "Decide on the style of yoga?",
            description: "What style of yoga do we want to practice?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What yoga styles should we include?",
                emoji: "🧘",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we provide after the class?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we have?",
                      emoji: "🥤",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Namaste!",
    outroDescription: "Your yoga class plans are set! Enjoy the tranquility!",
  },
};
